const dataRoadmap = [
    {
        id: 1,
        time: 'Février 07, 2026',
        text1: "Carna'dzons",
        text2: 'Saint-Martin VS',
        status: 'active'
    },
     {
         id: 2,
         time: 'Février 13, 2026',
         text1: 'Carnaval de Vex',
         text2: 'Vex',
         status: 'active'
     },
     {
         id: 3,
         time: 'Février 14, 2026',
         text1: 'Carnaval de Sion',
         text2: 'Sion',
         status: 'active'
     },
    {
        id: 4,
        time: 'Février 14, 2026',
        text1: 'Carnaval de Fully',
        text2: 'Fully',
        status: 'active'
    },
     {
         id: 5,
         time: 'Février 15, 2026',
         text1: 'Carnaval de Saint-Léonard',
         text2: 'Saint-Léonard',
         status: 'active'
     },


]

export default dataRoadmap;